export interface IConfiguration {
  config_name: string;
  config_type: string;
  config_owner: string;
  config_version: string;
}

export enum SessionType {
  /**
   * session will never exit
   */
  DEBUG_GC = "debug_gc",
  /**
   * session ends after a fixed period of time specified in BfxUIConfiguration.session.sessionDuration
   *
   *
   */
  LIMIT = "limit",
  /**
   * session ends after a fixed period of time since desktop was last idle or browser was last visible
   */
  VISIBILITY = "visibility",
}
export class BfxUIConfiguration implements IConfiguration {
  constructor(
    public config_name: string,
    public config_type: string, // options: system, client, user, test, install
    public config_owner: string, //
    public config_version: string,
    public general: {
      debug: boolean; // true or false
      homeRoute: string; // valid route
      showDevMenu: boolean;
      exportLimit: number;
      openExternalInTab: false;
      oboEnabled: false;
      loginTimeout: number;
      appNotifSoundThrottleInterval: number; // throttle application notifications, in milliseconds
    },
    public auth: {
      loadDelay: number;
      useDummyAuth: boolean; // dummy authentication for testing
      showLoadingLog: boolean; // flag, indicates whether to show (true) or hide (false) the textual log on loading screen
    },
    public session: {
      sessionType: SessionType;
      sessionTimeout: number;
      sessionDuration: number;
      showNotification: boolean; // show notification that session is about the expire
      notificationOffset: number; // in milliseconds the
      autoReconnectionTimeout: number; // if reconnection dialog is ignored reconnect after Xms or -1 to disable,
    },
  ) {}
}

export class BfxInstallConfiguration implements IConfiguration {
  constructor(
    public config_name: string,
    public config_type: string, // options: system, client, user, test, install
    public config_owner: string, //
    public config_version: string,
    public disclaimer: string,
    public download_text: string,
    public comment_warning: string,
  ) {}
}
